
import { FiCoffee } from "react-icons/fi";

export function Footer() {
  return (
    <footer className="footer">
        <div className="footer-content">
            <div className="logo"><FiCoffee /> CoffeeLaTek</div>
            <p>&copy; 2024 CoffeeLaTek. All rights reserved.</p>
        </div>
    </footer>
  );
}
